package com.eladfinish.bible.contest.features.deeplink

import com.eladfinish.bible.contest.navigation.NavigationDestination
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

/**
 * Receives deep link URLs from the platform entry points (Android intents,
 * iOS universal links) and keeps the parsed destination until the Compose
 * NavHost is ready to consume it (cold start support).
 */
class DeepLinkHandler {

    private val _pendingDestination = MutableStateFlow<NavigationDestination?>(null)
    val pendingDestination: StateFlow<NavigationDestination?> = _pendingDestination

    /** @return true if [url] is a recognized deep link. */
    fun onDeepLink(url: String): Boolean {
        val destination = DeepLinks.parse(url)
        Napier.d("onDeepLink url=$url destination=$destination")

        if (destination == null) return false

        _pendingDestination.value = destination
        return true
    }

    fun consume() {
        _pendingDestination.value = null
    }
}
